import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const StepHeader = styled.div`
	padding: 1rem 0; 
`;

export const StyledTableWrapper = styled.div`
  table {
    thead {
      display: none;
    }
  }
`;

export const StyledButton = styled.div`
  button {
    ${({ theme }) =>
      css`
      :hover {
        color:${theme.palette?.brand.primary.base};
        border-color: ${theme.palette?.brand.primary.base} !important;
        span {
          color:${theme.palette?.brand.primary.base};
        }
      }
    `}
  }
`;

export const StyledDownloadButton = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;

  span{
    font-size: 14px;
  }
`;

export const Title18 = styled.span`
  font-family: 'Poppins';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  color: ${({ theme }) => theme.palette?.text};
`;
